import { ReactComponent as EmptyIcon } from '@Icons/additional/no-data.svg';
import { Flex } from 'antd';

import { NoDataType } from '@Components/types/NoDataType';

import styles from './no-data.module.css';
import { getNoDataType, getText } from './utils';

interface NoDataProps {
  context: NoDataType;
  isFiltersApplied: boolean;
  isSearchApplied: boolean;
}

const NoData: React.FC<NoDataProps> = ({
  context,
  isFiltersApplied,
  isSearchApplied,
}) => {
  const noDataType = getNoDataType(context, isSearchApplied, isFiltersApplied);

  const { title, description } = getText(noDataType);

  return (
    <Flex vertical className={styles.wrapper}>
      <EmptyIcon />
      <Flex vertical className={styles.textWrapper}>
        <span className={styles.title}>{title}</span>
        <span className={styles.description}>
          {description[0]}
          <br />
          {description[1] || null}
        </span>
      </Flex>
    </Flex>
  );
};

export default NoData;
